<div
  class="box-border w-full text-base"
  [ngClass]="{
    'cursor-not-allowed opacity-60': ngControl.control!.disabled,
    'bg-primary-on': !corporateDesignService.isDarkModeActive(),
  }"
  [ngStyle]="{
    background: inputBackground(),
  }">
  @let hasError = ngControl.errors && ngControl.touched;
  <div class="relative w-full bg-inherit" [id]="id() | appendTestId: 'anchor'">
    <input
      [attr.data-testid]="id() | appendTestId: 'input'"
      autocomplete="off"
      [formControl]="searchControl"
      (click)="openDropdownList()"
      (focus)="isFocused.set(true)"
      (blur)="isFocused.set(false); tryToMatchSearchTerm()"
      class="border-input-ring border-input rounded-input peer p-input w-full bg-transparent placeholder-transparent focus:ring-0"
      [ngClass]="{
        'border-input-error focus:border-input-focus': hasError,
        'border-input-ring focus:border-input-focus': !hasError,
        'pointer-events-none': ngControl.disabled || isLoading(),
      }"
      [ngStyle]="{
        borderRadius: borderRounding(),
        borderColor: borderAndLabelColor(),
        color: corporateDesignService.fontColor(),
      }"
      [id]="id()"
      [placeholder]="label() ?? ''"
      type="text" />
    <label
      [attr.data-testid]="id() | appendTestId: 'label'"
      class="peer-placeholder-shown:text-input-label peer-focus:text-input-focus pointer-events-none absolute -top-2 right-4 left-4 w-fit max-w-[calc(100%-2rem)] cursor-text overflow-hidden bg-inherit text-sm overflow-ellipsis whitespace-nowrap transition-all peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-base peer-focus:-top-2 peer-focus:text-sm"
      [ngClass]="{
        'text-input-error': hasError,
      }"
      [ngStyle]="{
        color: borderAndLabelColor(),
      }"
      [for]="id()">
      {{ formattedLabel() }}
    </label>
    @if (
      !ngControl.control!.disabled &&
      ngControl.control!.value &&
      showResetIcon() &&
      !isLoading()
    ) {
      <span
        tabIndex="0"
        (keydown.enter)="
          searchControl.setValue(''); ngControl.control!.setValue('')
        "
        [ngStyle]="{
          background: inputBackground(),
        }"
        (click)="searchControl.setValue(''); ngControl.control!.setValue('')"
        [id]="id() | appendTestId: 'reset'"
        [attr.data-testid]="id() | appendTestId: 'reset'"
        class="material-symbols-rounded text-input-label absolute top-3 right-10 bottom-3 z-10 cursor-pointer text-2xl">
        close
      </span>
    }
    @if (!ngControl.control!.disabled && !isLoading()) {
      <span
        [id]="id() | appendTestId: 'arrow-down'"
        [attr.data-testid]="id() | appendTestId: 'arrow-down'"
        [ngStyle]="{
          background: inputBackground(),
        }"
        class="material-symbols-rounded text-input-label pointer-events-none absolute top-3 right-4 bottom-3 cursor-pointer text-2xl">
        {{ showList() ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
      </span>
    }
    @if (isLoading()) {
      <span
        [ngStyle]="{
          color: corporateDesignService.fontColor(),
        }"
        class="material-symbols-rounded pointer-events-none absolute top-3 right-4 bottom-3 animate-spin text-2xl"
        >progress_activity</span
      >
    }
    <ul
      awPopupPosition
      [anchor]="id() | appendTestId: 'anchor'"
      [isVisible]="showList()"
      tabindex="-1"
      [attr.data-testid]="id() | appendTestId: 'options'"
      [ngClass]="{
        hidden: !showList(),
        'bg-primary-on': !corporateDesignService.isDarkModeActive(),
        'bg-input-ring': corporateDesignService.isDarkModeActive(),
      }"
      [ngStyle]="{
        borderRadius: borderRounding(),
      }"
      class="focus:border-input-focus border-input-ring border-input rounded-input fixed z-10 -mt-px max-h-[300px] w-full overflow-y-scroll focus:outline-hidden">
      @for (option of filteredOptions(); track $index; let index = $index) {
        <li
          [attr.data-testid]="id() + index | appendTestId: 'option'"
          class="p-drop-down-list-item hover:bg-standard-hover-main cursor-pointer"
          [ngClass]="{
            'text-input-focus': selectedItem() === index,
          }"
          (mouseenter)="menuSelectSupport.highlightedLink.set($index)"
          (mouseleave)="menuSelectSupport.highlightedLink.set(undefined)"
          [style.color]="
            selectedItem() === $index
              ? menuSelectSupport.highlightedLinkColor()
              : corporateDesignService.fontColor()
          "
          [style.border-top-left-radius]="
            index === 0 ? borderRounding() : undefined
          "
          [style.border-top-right-radius]="
            index === 0 ? borderRounding() : undefined
          "
          [style.border-bottom-left-radius]="
            index === options()!.length - 1 ? borderRounding() : undefined
          "
          [style.border-bottom-right-radius]="
            index === options()!.length - 1 ? borderRounding() : undefined
          "
          [style.background-color]="
            menuSelectSupport.highlightedLink() === $index
              ? menuSelectSupport.highlightedLinkBackgroundColor()
              : ''
          "
          (click)="selectOptionAndSetItem(option, index)">
          {{ option | toSelectOptionAttribute: name() }}
        </li>
      }
      @if (filteredOptions()!.length === 0) {
        <li
          class="p-drop-down-list-item"
          [attr.data-testid]="id() | appendTestId: 'option'">
          {{
            textStore.texts()
              | filterTexts: ERelationType.noOptions : EEntityType.generic
              | language
          }}
        </li>
      }
    </ul>
  </div>
  @if (hasError && !errorTemplate()) {
    <aw-error-message [attr.data-testid]="id() | appendTestId: 'error'">
      <ng-content></ng-content>
    </aw-error-message>
  }
  @if (hasError && errorTemplate()) {
    <aw-error-message [attr.data-testid]="id() | appendTestId: 'error'">
      <ng-container *ngTemplateOutlet="errorTemplate()!"></ng-container>
    </aw-error-message>
  }
</div>
